import { defaultProps } from 'recompose';
import { SsmLolliplot } from './index';
export default defaultProps({ ssmId: 'a0fe6696-dd49-555d-bb9e-cdbec315dbb3' })(
  SsmLolliplot,
);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/Lolliplot/SsmLolliplot.fixture.js